<template>
  <div class="flex flex-col py-2">
    <div class="w-full">
      <div class="grid grid-cols-4 gap-3 py-3">
        <input
            type="text"
            v-model="name"
            placeholder="Search by Name"
            required
            class="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
            @keyup.enter="fetch(1)" />

        <input
            type="text"
            v-model="email"
            placeholder="Search by Email"
            required
            class="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
            @keyup.enter="fetch(1)" />

        <input
            type="text"
            v-model="phone"
            placeholder="Search by phone"
            required
            class="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
            @keyup.enter="fetch(1)" />

        <input
            type="text"
            v-model="idNumber"
            placeholder="Id Number"
            required
            class="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
            @keyup.enter="fetch(1)" />

        <select v-model="status" @change="fetch(1)"
                class="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent">
          <option :value="null">--Filter by Status--</option>
          <option :value="null">All</option>
          <option value="ACTIVE">Active</option>
          <option value="INACTIVE">Inactive</option>
        </select>
        <select v-model="gender" @change="fetch(1)"
                class="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent">
          <option :value="null">--Filter by gender--</option>
          <option :value="null">All</option>
          <option value="MALE">Male</option>
          <option value="FEMALE">Female</option>
        </select>

        <select v-model="idType" @change="fetch(1)"
                class="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent">
          <option :value="null">--Filter by ID Type--</option>
          <option :value="null">All</option>
          <option value="NATIONAL_ID">National Id</option>
          <option value="PASSPORT">Passport</option>
          <option value="ALIEN_ID">Alien ID</option>

        </select>
        <select v-model="nationality" @change="fetch(1)"
                class="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent">
          <option :value="null">--Nationality--</option>
          <option v-for="(nat,idx) in nationalities" :key="idx" :value="nat">
            {{ nat }}
          </option>
        </select>
      </div>
      <div class="grid grid-cols-12 gap-4 mt-2">
        <div class="col-span-12">
          <table class="min-w-full leading-normal">
            <thead>
            <tr class="border-b border-t border-gray-200">
              <th>Name</th>
              <th>ID Number</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Nationality</th>
              <th>Date Created</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
            </thead>

            <tbody>
            <template v-if="loading">
              <tr v-for="i in 6" :key="`sk-${i}`" class="animate-pulse">
                <td>
                  <div class="h-3 bg-gray-200 rounded w-full"></div>
                </td>
                <td>
                  <div class="h-3 bg-gray-200 rounded w-full"></div>
                </td>
                <td>
                  <div class="h-3 bg-gray-200 rounded w-full"></div>
                </td>
                <td>
                  <div class="h-3 bg-gray-200 rounded w-full"></div>
                </td>
                <td>
                  <div class="h-3 bg-gray-200 rounded w-full"></div>
                </td>
                <td>
                  <div class="h-3 bg-gray-200 rounded w-full"></div>
                </td>
                <td>
                  <div class="h-3 bg-gray-200 rounded w-full"></div>
                </td>
                <td>
                  <div class="h-3 bg-gray-200 rounded w-full"></div>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr :class="[(idx%2) ? rows.even : rows.odd]" v-for="(account, idx) in accounts" :key="idx">
                <td class="font-bold text-uppercase">
                  <span>{{ account.givenName ? account.givenName : "" }}</span>
                  <span class="mx-2">{{ account.surName ? account.surName : "" }}</span>
                  <span class="mx-2" v-if="account.middleName !== 'null'">{{
                      account.middleName ? account.middleName : ""
                    }}</span>
                </td>
                <td>
                  <div v-if="account.nationality =='Ugandan'">
                    <span>{{ account.idNumber }}</span><br />
                    <small class="text-green">({{
                        account.idType ? cleanUnderscoreString(account.idType) : ""
                      }})</small>
                  </div>
                  <div v-else class="cursor-pointer" @click="showIdAttachment(account.id)"
                       title="Click to view ID attachment">
                    <span class="text-primary text-sm">
                      <i class="fa fa-eye"></i>
                      {{ account.idNumber }}</span><br />
                    <small class="text-green">({{
                        account.idType ? cleanUnderscoreString(account.idType) : ""
                      }})</small>
                  </div>
                </td>
                <td>
                  <span>
                    <i class="fa fa-check-circle text-green mx-1" v-if="account.emailVerified"></i>
                    <i class="fa fa-times text-orange mx-1" v-else></i>
                    {{ account.email }}
                  </span>
                </td>
                <td>
                  <span>
                    <i class="fa fa-check-circle text-green mx-1" v-if="account.phoneVerified"></i>
                    <i class="fa fa-times text-orange mx-1" v-else></i>
                    {{ account.phoneNumber }}
                  </span>
                </td>
                <td>
                  <span>{{ account.nationality ? account.nationality : "" }}</span>
                </td>
                <td><span>{{ formatDate(account.createdAt) }}</span></td>
                <td class="font-bold">
                  <span class="text-green" v-if="account.enabled">Active</span>
                  <span class="text-red" v-else>Inactive</span>
                </td>
                <td>
                  <div class="flex gap-1 items-center">
                    <button class="btn-sm-danger"
                            v-if="account.enabled && canViewMenuItem('can_update_account_status')"
                            @click="changeStatus(account.id,'INACTIVE')"
                            title="Click to disable account">
                      <i class="fa fa-times mr-1"></i> Disable
                    </button>
                    <button class="btn-sm-primary"
                            v-else-if="canViewMenuItem('can_update_account_status')"
                            @click="changeStatus(account.id,'ACTIVE')"
                            title="Click to activate account">
                      <i class="fa fa-check mr-1"></i> Enable
                    </button>
                    <button class="btn-sm-primary"
                            v-if="!account.enabled && canViewMenuItem('can_resend_account_emails')"
                            title="Click to resend activation link"
                            @click="resendActivation(account.id)">
                      <i class="fa fa-reply mr-1"></i> Resend
                    </button>
                    <button class="btn-sm-primary"
                            v-if="canViewMenuItem('can_edit_user_contacts')"
                            title="Click to edit profile"
                            @click="openEditForm(account)">
                      <i class="fa fa-pen mr-1"></i> Edit
                    </button>
                    <button class="btn-sm-primary"
                            v-if="account.idType === 'NATIONAL_ID' && canViewMenuItem('can_revalidate_nin')"
                            :disabled="revalidatingId === account.id"
                            title="Click to revalidate NIN"
                            @click="revalidateNin(account)">
                      <i :class="revalidatingId === account.id ? 'fa fa-spinner fa-spin mr-1' : 'fa fa-sync mr-1'"></i> Revalidate NIN
                    </button>
                  </div>
                </td>
              </tr>
              <tr>
                <td v-if="accounts.length === 0" colspan="8" class="text-center py-6 text-sm text-gray-400">
                  No results found
                </td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
      </div>
      <div v-if="pagination.totalPages > 1"
           class="flex items-center justify-between px-1 py-3 border-t border-gray-100 mt-2">
        <p class="text-xs text-gray-500">Page <span class="font-semibold text-gray-700">{{ currentPage }}</span> of
          <span class="font-semibold text-gray-700">{{ pagination.totalPages }}</span></p>
        <div class="flex gap-2">
          <button class="btn-sm-primary" @click="previous" :disabled="currentPage === 1">
            <i class="fa fa-chevron-left mr-1"></i> Prev
          </button>
          <button class="btn-sm-primary" @click="next" :disabled="currentPage === pagination.totalPages">
            Next <i class="fa fa-chevron-right ml-1"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <AppModal v-model="showEditAccountForm" size="lg" title="Edit Account" hide-footer>
    <div class="col-span-11 mx-auto">
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <select v-model="editForm.idType" disabled class="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent">
            <option value="NATIONAL_ID">National ID</option>
          </select>
        </div>
        <div class="col-span-12">
          <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent my-2" :disabled="true"  v-model="editForm.idNumber"
                 placeholder="National ID Number" />
        </div>
      </div>
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent my-2" :disabled="true"  v-model="editForm.surname"
                 placeholder="Surname" />
        </div>
      </div>
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent my-2" :disabled="true" v-model="editForm.middleName"
                 placeholder="Middle Name" />
          <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent my-2" v-model="editForm.email"
                 placeholder="Email Address" />
        </div>
        <div class="col-span-12">
          <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent my-2" :disabled="true" v-model="editForm.givenName"
                 placeholder="Given Name" />
          <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent my-2" v-model="editForm.phoneNumber"
                 placeholder="Phone Number" />
        </div>
      </div>


      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-10"></div>
        <div class="col-span-2">
          <button class="btn-primary w-full bg-primary text-white px-2 py-1 rounded-md"
                  @click="updateUserDetails">
            <i class="fa fa-save mx-1"></i> Save changes
          </button>
        </div>
      </div>
    </div>
  </AppModal>

  <AppModal v-model="showRenderIdAttachment" size="lg" title="ID Preview" hide-footer>


    <a target="_blank"
       class="text-primary text-lg-center"
       :href="url || ''">
      Click this link
    </a> to View the attachment in case the attachment fails to load
    <iframe class="pdf" :src="url+'#toolbar=0&navpanes=0&scrollbar=0'"
            height="100%"
            width="100%">
    </iframe>
  </AppModal>

  <AppModal v-model="showSignatureForm" size="lg" title="Account profile picture" hide-footer>
    <div class="mb-2">
      <div class="mb-4">
        <h3 class="text-lg font-semibold text-gray-900 mb-4">Crop image</h3>
        <div class="text-sm text-gray-600">
          <VueCropper v-show="selectedFile" ref="cropper" :src="selectedFile"
                      alt="Source Image"></VueCropper>
        </div>
      </div>
      <div class="my-2 flex justify-between">
        <button class="btn-primary mx-2 px-4 py-2 text-white bg-red rounded hover:bg-red-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red"
                @click="showSignatureForm = false">Cancel
        </button>
        <button class="btn-primary mx-2 px-4 py-2 bg-primary text-white rounded hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                @click="saveImage(); (dialog = false) ">Crop
          logo
        </button>
      </div>
    </div>
  </AppModal>
</template>

<script setup lang="ts">
import { getCurrentInstance, onMounted, ref, watch } from "vue";
import { useAbility } from "@casl/vue";
import { useAccountStore } from "../stores";
import { useConfirmDialog } from "@/composables";
import AppModal from "@/components/ui/AppModal.vue";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import { cleanUnderscoreString } from "@/commons/composables/transformations.ts";
import { formatDate, objectToQueryParams } from "@/commons/composables/utilities.ts";
import { useNotificationsStore } from "@/app/notify/notifications.ts";
import { UserAccount } from "@/domains/home/services/accounts/types";

interface Account {
    id: string
    givenName: string
    surName: string
    middleName: string
    idNumber: string
    idType: string
    email: string
    phoneNumber: string
    nationality: string
    createdAt: string
    enabled: boolean
    emailVerified: boolean
    phoneVerified: boolean
}

interface EditForm {
    userId: string | null
    idType: string
    gender: string | null
    surname: string | null
    givenName: string | null
    middleName: string | null
    email: string | null
    phoneNumber: string | null
    roleId: string | null
    nationality: string
    idNumber: string | null
    idAttachment: string | null
    signature: string | null
    departmentId: string | null
    dob: string | null
}

interface Pagination {
    totalElements: number
    totalPages: number
}

const accountStore = useAccountStore();
const notify = useNotificationsStore();
const instance = getCurrentInstance();
const { showConfirm } = useConfirmDialog();

const showEditAccountForm = ref(false)
const showRenderIdAttachment = ref(false)
const showSignatureForm = ref(false)
const loading = ref(false)
const currentPage = ref(1)
const limit = ref(10)
const accounts = ref<UserAccount[]>([]);
const pagination = ref<Pagination>({
    totalElements: 0,
    totalPages: 0
})
const rows = ref({
    odd: "border-t border-gray-200 hover:bg-gray-10",
    even: "border-t border-gray-200 bg-gray-10"
})
const search = ref("")
const status = ref<string | null>(null)
const email = ref<string | null>(null)
const phone = ref<string | null>(null)
const name = ref<string | null>(null)
const gender = ref<string | null>(null)
const idType = ref<string | null>(null)
const idNumber = ref<string | null>(null)
const nationality = ref<string | null>(null)
const nationalities = ref([
    "Ugandan", "Afghan", "Albanian", "Algerian", "American", "Andorran", "Angolan", "Antiguans",
    "Argentinean", "Armenian", "Australian", "Austrian", "Azerbaijani", "Bahamian", "Bahraini",
    "Bangladeshi", "Barbadian", "Barbudans", "Batswana", "Belarusian", "Belgian", "Belizean",
    "Beninese", "Bhutanese", "Bolivian", "Bosnian", "Brazilian", "British", "Bruneian", "Bulgarian",
    "Burkinabe", "Burmese", "Burundian", "Cambodian", "Cameroonian", "Canadian", "Cape Verdean",
    "Central African", "Chadian", "Chilean", "Chinese", "Colombian", "Comoran", "Congolese",
    "Costa Rican", "Croatian", "Cuban", "Cypriot", "Czech", "Danish", "Djibouti", "Dominican",
    "Dutch", "East Timorese", "Ecuadorean", "Egyptian", "Emirian", "Equatorial Guinean", "Eritrean",
    "Estonian", "Ethiopian", "Fijian", "Filipino", "Finnish", "French", "Gabonese", "Gambian",
    "Georgian", "German", "Ghanaian", "Greek", "Grenadian", "Guatemalan", "Guinea-Bissauan",
    "Guinean", "Guyanese", "Haitian", "Herzegovinian", "Honduran", "Hungarian", "I-Kiribati",
    "Icelander", "Indian", "Indonesian", "Iranian", "Iraqi", "Irish", "Israeli", "Italian",
    "Ivorian", "Jamaican", "Japanese", "Jordanian", "Kazakhstani", "Kenyan", "Kittian and Nevisian",
    "Kuwaiti", "Kyrgyz", "Laotian", "Latvian", "Lebanese", "Liberian", "Libyan", "Liechtensteiner",
    "Lithuanian", "Luxembourger", "Macedonian", "Malagasy", "Malawian", "Malaysian", "Maldivan",
    "Malian", "Maltese", "Marshallese", "Mauritanian", "Mauritian", "Mexican", "Micronesian",
    "Moldovan", "Monacan", "Mongolian", "Moroccan", "Mosotho", "Motswana", "Mozambican", "Namibian",
    "Nauruan", "Nepalese", "New Zealander", "Nicaraguan", "Nigerian", "Nigerien", "North Korean",
    "Northern Irish", "Norwegian", "Omani", "Pakistani", "Palauan", "Panamanian", "Papua New Guinean",
    "Paraguayan", "Peruvian", "Polish", "Portuguese", "Qatari", "Romanian", "Russian", "Rwandan",
    "Saint Lucian", "Salvadoran", "Samoan", "San Marinese", "Sao Tomean", "Saudi", "Scottish",
    "Senegalese", "Serbian", "Seychellois", "Sierra Leonean", "Singaporean", "Slovakian", "Slovenian",
    "Solomon Islander", "Somali", "South African", "South Korean", "Spanish", "Sri Lankan", "Sudanese",
    "Surinamer", "Swazi", "Swedish", "Swiss", "Syrian", "Taiwanese", "Tajik", "Tanzanian", "Thai",
    "Togolese", "Tongan", "Trinidadian or Tobagonian", "Tunisian", "Turkish", "Tuvaluan", "Ukrainian",
    "Uruguayan", "Uzbekistani", "Venezuelan", "Vietnamese", "Welsh", "Yemenite", "Zambian", "Zimbabwean"
])
const type = ref<string | null>(null)
const editForm = ref<EditForm>({
    userId: null,
    idType: "NATIONAL_ID",
    gender: null,
    surname: null,
    givenName: null,
    middleName: null,
    email: null,
    phoneNumber: null,
    roleId: null,
    nationality: "UG",
    idNumber: null,
    idAttachment: null,
    signature: null,
    departmentId: null,
    dob: null
})
const url = ref<string | null>(null)
const mime_type = ref("")
const cropedImage = ref("")
const autoCrop = ref(false)
const selectedFile = ref("")
const image = ref("")
const dialog = ref(false)
const files = ref("")
const rawfile = ref<Blob | null>(null)
const userId = ref<string | null>(null)
const userName = ref<string | null>(null)
const cropper = ref<InstanceType<typeof VueCropper>>()

onMounted(() => {
    fetch(1)
})

const fetch = (startPage: number | null = null) => {
    loading.value = true
    let filters: any = { "accountType": "INDIVIDUAL" }

    if (status.value) {
        filters.accountStatus = status.value
    }
    if (gender.value) {
        filters.gender = gender.value
    }

    if (idType.value) {
        filters.idType = idType.value
    }

    if (name.value) {
        filters.name = name.value
    }

    if (email.value) {
        filters.email = email.value
    }

    if (phone.value) {
        filters.phone = phone.value
    }


    if (idNumber.value) {
        filters.idNumber = idNumber.value
    }


    if (nationality.value) {
        filters.nationality = nationality.value
    }

    filters.page = startPage ? startPage : currentPage.value
    filters.perPage = limit.value

  accountStore.fetchClientAccounts(objectToQueryParams(filters));
}

const next = () => {
    if (currentPage.value < pagination.value.totalPages) {
        currentPage.value++
        fetch()
    }
}

const resendActivation = (userId: string) => {
  accountStore.doResendActivationLink({ userId });
}

const previous = () => {
    if (currentPage.value > 1) {
        currentPage.value--
        fetch()
    } else {
        // @ts-ignore
        instance?.proxy?.warningToast("Observation", "No more data to show")
    }
}

const changeStatus = async (userId: string, status: string) => {
    const confirmed = await showConfirm(`Are you sure you want to change this account status to ${status.toLowerCase()}?`)
    if (confirmed) {
        await accountStore.changeAccountStatus({ userId, status })
        fetch()
    }
}

const openEditForm = (account: UserAccount) => {
    editForm.value = {
        userId: account.id,
        idType: "NATIONAL_ID",
        gender: null,
        surname: account.surName,
        givenName: account.givenName,
        middleName: account.middleName,
        email: account.email,
        phoneNumber: account.phoneNumber,
        roleId: null,
        nationality: account.nationality,
        idNumber: account.idNumber,
        idAttachment: null,
        signature: null,
        departmentId: null,
        dob: null
    }
    showEditAccountForm.value = true
}

const closeEditForm = () => {
    showEditAccountForm.value = false
}

const updateUserDetails = () => {
    let data = {
        "email": editForm.value.email,
        "phone": editForm.value.phoneNumber,
        "userId": editForm.value.userId
    }

  accountStore.updateStaffContacts(data);
}

const { can } = useAbility();
const canViewMenuItem = (permission: string) => can(permission, "general") === true;

const revalidatingId = ref<string | null>(null)

const revalidateNin = async (account: UserAccount) => {
    const nin = account.idNumber?.split(",")[0]?.trim()
    if (!nin) return
    revalidatingId.value = account.id
    try {
        const response = await accountStore.revalidateNin(nin)
        notify.success(response.data?.message || "NIN revalidated successfully")
        fetch()
    } catch (error: any) {
        notify.error(error.response?.data?.message || "Failed to revalidate NIN")
    } finally {
        revalidatingId.value = null
    }
}

const showIdAttachment = (userId: string) => {
  accountStore.fetchUserDetails(userId);
}

const saveImage = () => {
    if (cropper.value) {
        cropper.value.getCroppedCanvas().toBlob((blob) => {
            if (blob) {
                rawfile.value = blob
            }
        }, mime_type.value)
    }

    showSignatureForm.value = false
}

const onFileSelect = (e: Event) => {
    showCropper()
    const target = e.target as HTMLInputElement
    const file = target.files?.[0]
    if (!file) return

    mime_type.value = file.type

    if (typeof FileReader === "function") {
        dialog.value = true
        const reader = new FileReader()
        reader.onload = (event) => {
            selectedFile.value = event.target?.result as string
            if (cropper.value) {
                cropper.value.replace(selectedFile.value)
            }
        }
        reader.readAsDataURL(file)
    } else {
        alert("Sorry, FileReader API not supported")
    }
}

const showCropper = () => {
    showSignatureForm.value = true
}

// Watchers
watch(() => accountStore.user_accounts, (data) => {
  if (data) {
        loading.value = false
    accounts.value = data;
        pagination.value = {
          totalPages: accountStore.pagination?.data.totalPages || 1,
          totalElements: accountStore.pagination?.data.totalElements || 1
        }
    }
})

watch(() => accountStore.reactivationSuccess, (data) => {
    if (data) {
        // @ts-ignore
        instance?.proxy?.successToast("Success", data.message)
        loading.value = true
        closeEditForm()
        fetch()
    }
})

watch(() => accountStore.reactivationError, (error) => {
    if (error) {
        // @ts-ignore
        instance?.proxy?.errorToast(error.message, error.message)
    }
})

watch(() => accountStore.user_details, (data) => {
    if (data) {
        showRenderIdAttachment.value = true
        url.value = import.meta.env.VITE_API_BASE_URL + "/auth/api/users/downloadFile/attachment/" + data.attachmentUrl
    }
})
</script>
